import { type FC, type PropsWithChildren } from 'react'
import classNames from 'classnames'
import { CHIP_CLASS, tokenizeTemplateText } from './messageTemplatePlaceholders'
import { SettingsCard } from './SettingsSection'

interface TemplateTextProps {
  text: string
}

export const TemplateText: FC<TemplateTextProps> = ({ text }) => (
  <>
    {tokenizeTemplateText(text).map((token, index) =>
      token.type === 'chip' ? (
        <span key={index} className={CHIP_CLASS}>
          {token.value}
        </span>
      ) : (
        <span key={index}>{token.value}</span>
      ),
    )}
  </>
)

interface TemplateCardProps {
  regionId: string
  label: string
  description: string
  isExpanded: boolean
  onToggle: () => void
}

export const TemplateCard: FC<PropsWithChildren<TemplateCardProps>> = ({ regionId, label, description, isExpanded, onToggle, children }) => {
  const labelId = `${regionId}-label`

  return (
    <SettingsCard>
      <button
        type='button'
        className='d-flex align-items-center justify-content-between gap-3 py-3 zocks-px-1.25 border-0 bg-transparent text-start w-100'
        aria-expanded={isExpanded}
        aria-controls={regionId}
        onClick={onToggle}
      >
        <span className='d-flex flex-column'>
          <span id={labelId} className='bold'>
            {label}
          </span>
          <span className='paragraph-small zocks-text-gray-600'>{description}</span>
        </span>
        <i aria-hidden='true' className={classNames('bi zocks-text-gray-500', isExpanded ? 'bi-chevron-up' : 'bi-chevron-down')} />
      </button>
      {isExpanded ? (
        <div id={regionId} role='region' aria-labelledby={labelId} className='px-3 pb-3'>
          {children}
        </div>
      ) : null}
    </SettingsCard>
  )
}

export const TemplateGroup: FC<PropsWithChildren<{ title: string }>> = ({ title, children }) => (
  <div className='d-flex flex-column zocks-gap-0.75'>
    <h6 className='mb-0 zocks-text-gray-900'>{title}</h6>
    <div className='d-flex flex-column gap-2'>{children}</div>
  </div>
)
